module.exports = __webpack_public_path__ + "static/media/icon-warning2.0db57b00.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-warning2.svg
// module id = 1495
// module chunks = 0